import { createStore } from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { UserRecent } from '@thiememeulenhoff/types';

export const userRecents = createStore(
  { name: 'userRecents' },
  withEntities<UserRecent, 'subjectIdentifier'>({
    idKey: 'subjectIdentifier',
  }),
);
